<template>
  <div class="checkInfo">
    <div class="detail">
      <div class="detail">
        <div class="nowrapDiv">
          <div class="detailDiv">
            <div class="width1 fontBold">物件番号</div>
            <div>{{ paintDetail.wujian_id }}</div>
          </div>
          <div class="detailDiv">
            <div class="width1 fontBold">物件名</div>
            <div>{{ paintDetail.wujian_name }}</div>
          </div>
        </div>
        <div class="nowrapDiv">
          <div class="detailDiv">
            <div class="width1 fontBold">生产批号</div>
            <div>{{ paintDetail.batch_no }}</div>
          </div>
          <div class="detailDiv">
            <div class="width1 fontBold">型材番号</div>
            <div>{{ paintDetail.xingcai_no }}</div>
          </div>
        </div>
        <div class="nowrapDiv">
          <div class="detailDiv">
            <div class="width1 fontBold">涂料名</div>
            <div>{{ paintDetail.paint_name }}</div>
          </div>
          <div class="detailDiv">
            <div class="width1 fontBold">御指定色</div>
            <div>{{ paintDetail.yu_color }}</div>
          </div>
        </div>
        <div class="nowrapDiv">
          <div class="width3 fontBold">涂装式样</div>
          <div>{{ paintDetail.specification_name }}</div>
        </div>
        <div class="nowrapDiv">
          <div class="width3 fontBold">再手配编号</div>
          <div>{{ paintDetail.zaishoupei_no }}</div>
        </div>
      </div>
    </div>
    <div class="detail" v-if="parentData.check_no.includes('QCL')">
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="fontBold">检查编号：</div>
          <div>{{ parentData.check_no }}</div>
        </div>
        <div class="detailDiv">
          <div class="fontBold">完工数：</div>
          <div>{{ parentData.completed_count }}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="fontBold">检查结果：</div>
          <div v-show="parentData.result === 'true'">合格</div>
          <div v-show="parentData.result === 'false'">不合格</div>
          <div v-show="parentData.result === 'recheck_true'">重检合格</div>
          <div v-show="parentData.result === 'recheck_false'">重检不合格</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="fontBold">检查员：</div>
          <div>{{ parentData['name@create_user_id'] }}</div>
        </div>
        <div class="detailDiv">
          <div class="fontBold">检查时间：</div>
          <div>{{ parentData.create_time }}</div>
        </div>
      </div>
    </div>
    <div class="detail" v-else-if="parentData.check_no.includes('MH')">
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="fontBold">检查编号：</div>
          <div>{{ parentData.check_no }}</div>
        </div>
        <div class="detailDiv">
          <div class="fontBold">完工数：</div>
          <div>{{ parentData.completed_count }}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="fontBold">光沢实测值：</div>
          <div>{{ parentData.guanchi_value }}</div>
        </div>
        <div class="detailDiv">
          <div class="fontBold">色调实测值：</div>
          <div>{{ parentData.hue_value }}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="fontBold">1-L ：</div>
          <div>{{ parentData.thickness_1l }}</div>
        </div>
        <div class="detailDiv">
          <div class="fontBold">2-L ：</div>
          <div>{{ parentData.thickness_2l }}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="fontBold">1-M ：</div>
          <div>{{ parentData.thickness_1m }}</div>
        </div>
        <div class="detailDiv">
          <div class="fontBold">2-M ：</div>
          <div>{{ parentData.thickness_2m }}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="fontBold">1-R ：</div>
          <div>{{ parentData.thickness_1r }}</div>
        </div>
        <div class="detailDiv">
          <div class="fontBold">2-R ：</div>
          <div>{{ parentData.thickness_2r }}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="fontBold">3-L ：</div>
          <div>{{ parentData.thickness_3l }}</div>
        </div>
        <div class="detailDiv">
          <div class="fontBold">4-L ：</div>
          <div>{{ parentData.thickness_4l }}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="fontBold">3-M ：</div>
          <div>{{ parentData.thickness_3m }}</div>
        </div>
        <div class="detailDiv">
          <div class="fontBold">4-M ：</div>
          <div>{{ parentData.thickness_4m }}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="fontBold">3-R ：</div>
          <div>{{ parentData.thickness_3r }}</div>
        </div>
        <div class="detailDiv">
          <div class="fontBold">4-R ：</div>
          <div>{{ parentData.thickness_4r }}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="fontBold">5-L ：</div>
          <div>{{ parentData.thickness_5l }}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="fontBold">5-M ：</div>
          <div>{{ parentData.thickness_5m }}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="fontBold">5-R ：</div>
          <div>{{ parentData.thickness_5r }}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="fontBold">检查结果：</div>
          <div v-show="parentData.result === 'true'">合格</div>
          <div v-show="parentData.result === 'false'">不合格</div>
          <div v-show="parentData.result === 'recheck_true'">重检合格</div>
          <div v-show="parentData.result === 'recheck_false'">重检不合格</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="fontBold">检查员：</div>
          <div>{{ parentData['name@create_user_id'] }}</div>
        </div>
        <div class="detailDiv">
          <div class="fontBold">检查时间：</div>
          <div>{{ parentData.create_time }}</div>
        </div>
      </div>
    </div>
    <div class="detail" v-else>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="fontBold">检查编号：</div>
          <div>{{ parentData.check_no }}</div>
        </div>
        <div class="detailDiv">
          <div class="fontBold">完工数：</div>
          <div>{{ parentData.completed_count }}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="fontBold">检查结果：</div>
          <div v-show="parentData.result === 'true'">合格</div>
          <div v-show="parentData.result === 'false'">不合格</div>
          <div v-show="parentData.result === 'recheck_true'">重检合格</div>
          <div v-show="parentData.result === 'recheck_false'">重检不合格</div>
        </div>
        <div class="detailDiv" v-show="parentData.result === 'false' || parentData.result === 'recheck_false'">
          <div class="fontBold">不良原因：</div>
          <div>{{ parentData.ng_reason }}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="fontBold">检查员：</div>
          <div>{{ parentData['name@create_user_id'] }}</div>
        </div>
        <div class="detailDiv">
          <div class="fontBold">检查时间：</div>
          <div>{{ parentData.create_time }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TuZhuangQcl",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      parentData1: {},
      paintDetail: {},
    }
  },
  methods: {
    async getPaintDetail() {
      let {data: res} = await this.$axios.get('/api/paint/detail?id=' + this.parentData.paint_id);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        this.paintDetail = res.data
      }
    },
  },
  created() {
    this.getPaintDetail()
  },
  beforeCreate() {
    this.parentData1 = this.parentData
    // if (this.parentData1.check_no.includes('QCL')){
    //   if (this.parentData1.result === 'true'){
    //     this.parentData1.qclResult = '合格'
    //   }else if(this.parentData1.result === 'false'){
    //     this.parentData1.qclResult = '不合格'
    //   }else if(this.parentData1.result === 'recheck_true'){
    //     this.parentData1.qclResult = '重检合格'
    //   }else {
    //     this.parentData1.qclResult = '重检不合格'
    //   }
    // }
    console.log(this.parentData)
  }
}
</script>

<style scoped>
.checkInfo {
  background-color: #F4F8FD;
}

.detail {
  background-color: #FFFFFF;
  margin: 5px;
  border-radius: 5px;
  padding: 5px;
  font-size: 16px;
}

.detailDiv {
  width: 50%;
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fontBold {
  font-weight: bold;
}

.width1 {
  width: 30%;
}

.width2 {
  width: 39%;
}

.width3 {
  width: 15%;
}

.width4 {
  width: 30%;
}

.width5 {
  width: 50%;
}

.nowrapDiv {
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ngdiv {
  width: 50px;
  height: 25px;
  background-color: #F1F1F1;
  margin-right: 5px;
  margin-bottom: 5px;
}

.ngdiv1 {
  font-size: 12px;
  width: 50px;
  height: 25px;
  background-color: #1A73E8;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  margin-bottom: 5px;
}

.imageStyle {
  width: 87px;
  height: 87px;
  margin-right: 5px
}
</style>
